module.exports = __webpack_public_path__ + "static/social-b0c2a7cb38167b3416528094dde1bd55.jpg";